
// ROUTES FOR THE APP
export const ROUTE = {
  // Auth routes
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  newPassword: "/new-password",
  verifyEmail: "/verify-email",

  // unprotected routes
  home: "/",
  about: "/about",

  course: "/courses",
  course_details: "/courses/details/",
  contact: "/contact",
  events: "/events",
  event_details: "/events/details/",
  findMyTicket: "/events/find-my-tickets",
  event_ticket_purchase: "/events/ticket-purchase/",
  blog: "/blog",
  blog_details: "/blog/post/",
  faq: "/faq",
  privacy: "/privacy-policy",
  terms: "/terms",
  Faq: "/faq",
  view_all_categories: "/courses",
  certificate: "/certificate/",
  certificateVerify: "/certificate/verify/",
  tutor: "/tutors/",
  instructors: "/instructors",

  // protected routes
  dashboard: "/dashboard/overview",
  dashboardProfile: "/dashboard/student-profile",
  notifications: "/dashboard/notifications",
  appeal: "/appeal",
  dashboardAppeals: "/dashboard/appeals",
  dashboardWishlist: "/dashboard/wishlist",
  dashboardBrowseCourses: "/dashboard/browse-courses",
  dashboardEvents: "/dashboard/events",
  dashboardEventsCreate: "/dashboard/create-event",
  dashboardEventsEdit: "/dashboard/edit-event",
  dashboardEventsRePurposing: "/dashboard/re-purpose-event",
  dashboardEventTicketPurchasing: "/dashboard/purchase-event-ticket",
  eventTicketBookings: "/dashboard/event-ticket-bookings",
  dashboardClassRoom: "/dashboard/class-room",
  dashboardSettings: "/dashboard/settings",
  dashboardCertificates: "/dashboard/certificates",
  enrolledCourse: "/dashboard/enrolled-courses",
  studentQuizAttempts: "/dashboard/student-quiz-attempts",
  module3: "/dashboard/module3",
  dashboardCourseDetails: "/dashboard/courses/",
  dashboardEventDetails: "/dashboard/events/",
  dashboardTutor: "/dashboard/tutors/",

  // admin routes
  adminOverview: "/admin/overview",
  adminCourses: "/admin/courses",
  adminCoursesCreate: "/admin/courses/create",
  adminCoursesEdit: "/admin/courses/edit",
  adminEnrollments: "/admin/enrollments",
  adminUsers: "/admin/users",
  adminSecurityIncidents: "/admin/security-incidents",
  adminEvents: "/admin/events",
  adminAppeals: "/admin/appeals",
  adminTickets: "/admin/tickets",
  adminCourseDetails: "/admin/courses/",
  adminEventDetails: "/admin/events/",
  adminReports: "/admin/reports",
  adminModeration: "/admin/moderation",
  adminCourseCollections: "/admin/course-collections",
  adminSettings: "/admin/settings",

  // LINKS TO WEBSITE FOR TECH STACKS
  SPRING: "https://spring.io/projects/spring-framework",
  LARAVEL: "https://laravel.com",
  NEXT: "https://nextjs.org",
  VITE: "https://vitejs.dev",
  REACT: "https://react.dev",
  TAILWINDCSS: "https://tailwindcss.com",
  BOOTSTRAP: "https://getbootstrap.com",

  // SOCIALS LINKS
  FACEBOOK: "https://www.facebook.com/smarttechacademy",
  TWITTER: "https://www.x.com/smarttechacademy",
  INSTAGRAM: "https://www.instagram.com/smarttechacademy",
  LINKEDIN: "https://www.linkedin.com/company/smarttechacademy",
  SKYPE: "https://www.skype.com/smarttechacademy",
  YOUTUBE: "https://www.youtube.com/smarttechacademy",
};

// complex if-else
// {isActive("/questions-types")
// ? 1
// : isActive("/all-questions")
// ? 2
// : isActive("/pagination-quiz")
// ? 3
// : isActive("/single-question")
// ? 4
// : isActive("/quiz-with-point")
// ? 5
// : isActive("/quiz-with-custom-timer")
// ? 6
// : isActive("/quiz-passing-grade")
// ? 7
// : isActive("/lesson-quiz")
// ? 8
// : isActive("/lesson-quiz-result")
// ? 9
// : 0}
